import { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FaComments, FaMapMarkedAlt } from 'react-icons/fa';
import CtaButton from './CtaButton';
import { SITE_NAME } from '../constants/site';
import { openSalesIQChat } from '../utils/openSalesIQChat';
import './Header.css';

const navLinks = [
  { to: '/', label: 'Home' },
  { to: '/#services', label: 'Services' },
  { to: '/#guides', label: 'Guides' },
  { to: '/#support', label: 'Support' },
];

export default function Header() {
  const [menuOpen, setMenuOpen] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    setMenuOpen(false);
  }, [pathname]);

  useEffect(() => {
    document.body.classList.toggle('menu-open', menuOpen);
    return () => document.body.classList.remove('menu-open');
  }, [menuOpen]);

  const closeMenu = () => setMenuOpen(false);

  const handleChatClick = () => {
    closeMenu();
    openSalesIQChat();
  };

  return (
    <header className="gps-header">
      <div className="container gps-header-inner">
        <div className="gps-header-bar">
          <Link to="/" className="gps-brand" onClick={closeMenu}>
            <span className="gps-brand-icon" aria-hidden="true">
              <FaMapMarkedAlt />
            </span>
            <span className="gps-brand-text">{SITE_NAME}</span>
          </Link>

          <nav className="gps-nav-desktop" aria-label="Main navigation">
            {navLinks.map((link) => (
              <Link key={link.label} to={link.to} className="gps-nav-link">
                {link.label}
              </Link>
            ))}
            <button
              type="button"
              className="btn btn-outline gps-header-chat btn--inline"
              onClick={handleChatClick}
            >
              <FaComments aria-hidden="true" />
              Live Chat
            </button>
            <CtaButton className="btn btn-primary gps-header-cta btn--inline">
              Update Maps
            </CtaButton>
          </nav>

          <button
            type="button"
            className="gps-menu-toggle"
            onClick={() => setMenuOpen((open) => !open)}
            aria-label={menuOpen ? 'Close menu' : 'Open menu'}
            aria-expanded={menuOpen}
          >
            {menuOpen ? '✕' : '☰'}
          </button>
        </div>

        {menuOpen && (
          <nav className="gps-nav-mobile" aria-label="Mobile navigation">
            {navLinks.map((link) => (
              <Link key={link.label} to={link.to} className="gps-nav-link" onClick={closeMenu}>
                {link.label}
              </Link>
            ))}
            <button type="button" className="btn btn-outline" onClick={handleChatClick}>
              <FaComments aria-hidden="true" />
              Live Chat
            </button>
            <CtaButton className="btn btn-primary" onClick={closeMenu}>
              Update Maps
            </CtaButton>
          </nav>
        )}
      </div>
    </header>
  );
}
